import { render, staticRenderFns } from "./ota-device-list.vue?vue&type=template&id=38a65595&scoped=true&"
import script from "./ota-device-list.vue?vue&type=script&lang=ts&"
export * from "./ota-device-list.vue?vue&type=script&lang=ts&"
import style0 from "./ota-device-list.vue?vue&type=style&index=0&id=38a65595&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a65595",
  null
  
)

export default component.exports